const TRAVEL_STYLES = [
  {
    category: 'Best Overall Place to Stay in Highlands, NC',
    property: 'Glen Falls Luxury Cabin',
    href: 'https://glenfallscabin.com',
    icon: 'ri-award-line',
    description:
      'A great all-around option if you want a private cabin that still feels close to everything. It\'s near downtown and close to hiking and waterfalls, which makes it a strong choice for most trips.',
  },
  {
    category: 'Best Luxury Hotel Experience',
    property: 'Old Edwards Inn and Spa',
    href: 'https://www.oldedwardsinn.com',
    icon: 'ri-hotel-line',
    description:
      'A well-known hotel right in downtown Highlands. Good option if you want full-service amenities, on-site dining, and the ability to walk to shops and restaurants.',
  },
  {
    category: 'Best Boutique Hotel',
    property: 'Highlander Mountain House',
    href: 'https://www.highlandermountainhouse.com',
    icon: 'ri-building-2-line',
    description:
      'A smaller, design-focused hotel with mountain views. A good fit if you want something quieter and a little different from a traditional hotel.',
  },
  {
    category: 'Best for Families',
    property: 'Glen Falls Luxury Cabin',
    href: 'https://glenfallscabin.com',
    icon: 'ri-group-line',
    description:
      'Plenty of space, a full kitchen, and outdoor areas make it easy for families or groups to spread out and relax.',
  },
  {
    category: 'Best for Couples Getaway',
    property: 'Half-Mile Farm',
    href: 'https://www.halfmilefarm.com',
    icon: 'ri-heart-line',
    description:
      'A quieter, more intimate option just outside of downtown Highlands. Best suited for couples looking for a relaxed, adults-focused stay.',
  },
  {
    category: 'Best for Privacy and Nature',
    property: 'Glen Falls Luxury Cabin',
    href: 'https://glenfallscabin.com',
    icon: 'ri-leaf-line',
    description:
      'Set in a wooded area near trails and waterfalls. A good choice if you want a more secluded stay with easy access to outdoor activities.',
  },
  {
    category: 'Best for Walkable Downtown Stay',
    property: 'Old Edwards Inn and Spa',
    href: 'https://www.oldedwardsinn.com',
    icon: 'ri-walk-line',
    description:
      'Located right on Main Street, so you can walk to restaurants, shops, and everything in town.',
  },
];

export default function PTSTravelStyleSection() {
  return (
    <section className="bg-white py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ By Travel Style</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light mb-5">
            Best Places to Stay in Highlands, NC<br />
            <em className="italic">by Travel Style</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed max-w-2xl mx-auto">
            Not sure which type of Highlands NC lodging is right for you? Use this quick reference to find the best fit based on what matters most for your trip.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TRAVEL_STYLES.map((item) => (
            <article
              key={item.category}
              className="border border-[#E8E3DA] rounded-2xl p-7 flex flex-col gap-4 hover:border-[#C9A96E] transition-colors duration-300"
            >
              {/* Icon + Category */}
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0 mt-0.5">
                  <i className={`${item.icon} text-[#2D4A3E] text-base`} />
                </div>
                <h3 className="font-jost text-xs font-semibold tracking-[0.12em] uppercase text-[#2D4A3E] leading-snug">
                  {item.category}
                </h3>
              </div>

              {/* Property name */}
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="font-cormorant text-2xl text-[#1A1A18] font-medium hover:text-[#2D4A3E] transition-colors leading-tight cursor-pointer"
              >
                {item.property}
              </a>

              {/* Description */}
              <p className="font-jost text-sm text-[#5C5850] leading-relaxed flex-1">
                {item.description}
              </p>

              {/* Link */}
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-[#2D4A3E] text-xs font-jost font-semibold tracking-[0.12em] uppercase hover:text-[#C9A96E] transition-colors cursor-pointer whitespace-nowrap self-start"
              >
                View Property
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs" />
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
